import { render, staticRenderFns } from "./ProductCP2.vue?vue&type=template&id=dac066ea&scoped=true&"
import script from "./ProductCP2.vue?vue&type=script&lang=js&"
export * from "./ProductCP2.vue?vue&type=script&lang=js&"
import style0 from "./ProductCP2.vue?vue&type=style&index=0&id=dac066ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac066ea",
  null
  
)

export default component.exports